import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import {InfoTooltipHoverComponent} from './info-tooltip-hover.component';

@Directive({
    selector: '[dbInfoTooltipHover]',
    standalone: false
})
export class InfoTooltipHoverDirective implements OnDestroy {

  @Input('dbInfoTooltipHoverPosition') position: 'top'|'bottom'|'left'|'right'|'right-ltd'|'dropdown'|'bottom-right'|'bottom-left'|'bottom-right-wp'|'top-right-wp'|'top-left-wp'|'top-right-tw-care'|'top-right'|'top-left'|'top-left-additional'|'google-score-desc'|'bottom-right-front'|'bottom-right-header'|'bottom-from-start'|'top-from-start'|'top-from-end'|'top-from-start-ltd'|'top-from-start-ltd-price'|'pricing-tooltip'|'top-custom'|'bottom-right-cp-website'|'left-custom';
  @Input('dbInfoTooltipHoverDelay') delay: number;
  @Input('premiumUpgrade') premiumUpgrade: boolean;
  @Input('shadow') shadow: boolean = true;
  @Input('withImage') withImage: boolean = false;
  @Input('smallTooltip') smallTooltip: boolean = false;
  @Input('dbInfoTooltipHoverHeader') infoTooltipHoverHeader: string;
  @Input('dbInfoTooltipHoverBody') infoTooltipHoverBody: string;
  @Input('dbInfoTooltipMoreInfoLink') infoTooltipMoreInfoLink: string;
  @Input('dbInfoTooltipMoreInfoLinkText') infoTooltipMoreInfoLinkText: string;
  @Input('dbInfoTooltipHoverMoreInfo') infoTooltipHoverMoreInfo: string;
  @Input('dbInfoTooltipHoverCustomClass') dbInfoTooltipHoverCustomClass?: string;
  @Input('dbTooltipVisibility') visibility: boolean = true;
  @Input('dbTooltipColor') infoTooltipColor: string = 'white';
  @Input('gapVertical') gapVertical?: number;
  @Input('gapHorizontal') gapHorizontal?: number;
  @Input('gapPositionVertical') gapPositionVertical?: string;
  @Input('gapPositionHorizontal') gapPositionHorizontal?: string;
  @Input('eventTitle') eventTitle?: string;

  private _dbInfoTooltipHoverComponentRef: ComponentRef<InfoTooltipHoverComponent>;
  private _mouseLeaveTimeout: any;

  constructor(
    private _element: ElementRef,
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) {}

  @HostListener('mouseover') onMouseOver() {
    this.showInfoTooltip();
  }

  private showInfoTooltip(): void {
    if (!this.visibility) {
      return;
    }

    if (this._dbInfoTooltipHoverComponentRef) {
      return;
    }

    // create a dropdown component reference
    this._dbInfoTooltipHoverComponentRef = this._componentFactoryResolver.resolveComponentFactory(InfoTooltipHoverComponent).create(this._injector);
    this._dbInfoTooltipHoverComponentRef.instance.host = this._element.nativeElement;
    this._dbInfoTooltipHoverComponentRef.instance.position = this.position || 'top';
    this._dbInfoTooltipHoverComponentRef.instance.delay = this.delay;
    this._dbInfoTooltipHoverComponentRef.instance.premiumUpgrade = this.premiumUpgrade;
    this._dbInfoTooltipHoverComponentRef.instance.shadow = this.shadow;
    this._dbInfoTooltipHoverComponentRef.instance.withImage = this.withImage;
    this._dbInfoTooltipHoverComponentRef.instance.smallTooltip = this.smallTooltip;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipHoverMoreInfo = this.infoTooltipHoverMoreInfo;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipHoverBody = this.infoTooltipHoverBody;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipHoverHeader = this.infoTooltipHoverHeader;
    this._dbInfoTooltipHoverComponentRef.instance.dbInfoTooltipHoverCustomClass = this.dbInfoTooltipHoverCustomClass;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipMoreInfoLink = this.infoTooltipMoreInfoLink;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipMoreInfoLinkText = this.infoTooltipMoreInfoLinkText;
    this._dbInfoTooltipHoverComponentRef.instance.infoTooltipColor = this.infoTooltipColor;
    this._dbInfoTooltipHoverComponentRef.instance.eventTitle = this.eventTitle;
    this._dbInfoTooltipHoverComponentRef.instance.gapVertical = this.gapVertical;
    this._dbInfoTooltipHoverComponentRef.instance.gapHorizontal = this.gapHorizontal;
    this._dbInfoTooltipHoverComponentRef.instance.gapPositionVertical = this.gapPositionVertical;
    this._dbInfoTooltipHoverComponentRef.instance.gapPositionHorizontal = this.gapPositionHorizontal;
    this._dbInfoTooltipHoverComponentRef.instance.cancelHideEvent.subscribe(event => {
      if ( event === 'show' ) {
        clearTimeout(this._mouseLeaveTimeout);
      }
      else {
        this.hideInfoTooltipHover();
      }
    });
    // attach component to the applicationRef so that it will be dirty checked.
    this._applicationRef.attachView(this._dbInfoTooltipHoverComponentRef.hostView);

    // get DOM element from component
    const infoTooltipHoverComponentElement: HTMLElement = (this._dbInfoTooltipHoverComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.body.appendChild(infoTooltipHoverComponentElement);
  }

  private hideInfoTooltipHover(): void {
    this._dbInfoTooltipHoverComponentRef && this._dbInfoTooltipHoverComponentRef.destroy();
    this._dbInfoTooltipHoverComponentRef = null;
  }

  @HostListener('mouseleave') mouseleave() {
    this._mouseLeaveTimeout = setTimeout((): void => {
      this.hideInfoTooltipHover();
    }, 0 );
  }

  ngOnDestroy() {
    this.hideInfoTooltipHover();
  }

}
